
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Google'
})
export default class Google extends Vue {}
